import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Button } from './common/Button';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-[#f8f5ff] pt-6" data-id="element-162">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-163">
        <div className="flex justify-between items-center py-4" data-id="element-164">
          {/* Logo */}
          <div className="flex items-center" data-id="element-165">
            <div className="h-20 flex items-center" data-id="element-166">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pr8aEPnyhYBiZB5ruVSA7e/image.png" alt="Kraya Logo" className="h-56 object-contain" style={{
              marginTop: '-30px',
              marginBottom: '-60px'
            }} data-id="element-167" />
            </div>
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-168">
            <a href="#how-it-works" className="text-gray-700 hover:text-[#A020F0] transition-colors font-medium text-lg px-2 py-1" data-id="element-169">
              How It Works
            </a>
            <a href="#merchants" className="text-gray-700 hover:text-[#A020F0] transition-colors font-medium text-lg px-2 py-1" data-id="element-170">
              For Merchants
            </a>
            <Button variant="primary" size="lg" className="py-3 px-8" href="https://kraya.live" onClick={e => {
            e.preventDefault();
            window.open('https://kraya.live', '_blank');
          }} data-id="element-171">
              Join Waitlist
            </Button>
          </nav>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-172">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-700 hover:text-[#A020F0] focus:outline-none" data-id="element-173">
              {isMenuOpen ? <XIcon className="h-6 w-6" data-id="element-174" /> : <MenuIcon className="h-6 w-6" data-id="element-175" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white/80 backdrop-blur-sm shadow-md" data-id="element-176">
          <div className="px-4 pt-2 pb-4 space-y-3" data-id="element-177">
            <a href="#how-it-works" className="block py-2 text-gray-700 hover:text-[#A020F0] font-medium text-lg" onClick={() => setIsMenuOpen(false)} data-id="element-178">
              How It Works
            </a>
            <a href="#merchants" className="block py-2 text-gray-700 hover:text-[#A020F0] font-medium text-lg" onClick={() => setIsMenuOpen(false)} data-id="element-179">
              For Merchants
            </a>
            <div className="pt-2" data-id="element-180">
              <Button variant="primary" size="full" href="https://kraya.live" onClick={e => {
            e.preventDefault();
            window.open('https://kraya.live', '_blank');
            setIsMenuOpen(false);
          }} data-id="element-181">
                Join Waitlist
              </Button>
            </div>
          </div>
        </div>}
    </header>;
}